import React from 'react'
import PropTypes from 'prop-types'
import { FullscreenModal } from 'belle-js'
import connectModal from 'connectModal'
import modalStyles from '../Modals.module.scss'

const ContingentBeneficiaryModal = (props) => {
  const {
    isOpen,
    closeModal,
    isActiveModal,
  } = props

  return (
    <FullscreenModal
      isOpen={isOpen}
      isActiveModal={isActiveModal}
      className={modalStyles.Modal}
      onClose={closeModal}
      testId="contingetBeneficiaryInfoModal">
      <h2>
        What is a contingent beneficiary?
      </h2>

      <p>
        If no primary beneficiary survives you, the full value of your
        account will be paid to the contingent beneficiary(ies) that you designate.
      </p>

      <p>Things to consider:</p>

      <ul>
        <li>
          In the case of multiple contingent beneficiaries, the full value will
          be paid in equal proportions unless you indicate otherwise.
        </li>
        <li>
          If a contingent beneficiary predeceases you, the remaining portion
          will be divided proportionately to any of your surviving contingent beneficiaries.
        </li>
        <li>
          If no Contingent Beneficiary survives you, the full value of your
          Account will be paid to your estate.
        </li>
      </ul>

      <div className={modalStyles.actions}>
        <button
          type="button"
          className="button button--primary"
          onClick={closeModal}>
          Got it!
        </button>
      </div>
    </FullscreenModal>
  )
}

ContingentBeneficiaryModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  isActiveModal: PropTypes.bool.isRequired
}


export default connectModal(ContingentBeneficiaryModal, 'contingentBeneficiaryModal')



// WEBPACK FOOTER //
// ./src/components/Onboarding/Modals/ContingentBeneficiaryModal/ContingentBeneficiaryModal.jsx